import { differenceInHours } from 'date-fns';

export function calculateDaysLeft(trialEndDate: string | Date, now: Date) {
  return Math.round(Math.max(differenceInHours(new Date(trialEndDate), now) / 24));
}
